import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { UserStateType } from "../reducer/user.reducer"

const userState = (state: RootState) => state.userStore as UserStateType

export const selectUserDashboards = createDraftSafeSelector(userState, (store: UserStateType) => store.userDashboards)
export const selectPredefinedDashboards = createDraftSafeSelector(userState, (store: UserStateType) => store.predefinedDashboards)